import { render, staticRenderFns } from "./garden24.vue?vue&type=template&id=2cdb1b05"
import script from "./garden24.vue?vue&type=script&lang=js"
export * from "./garden24.vue?vue&type=script&lang=js"
import style0 from "./garden24.vue?vue&type=style&index=0&id=2cdb1b05&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports